import React from 'react'
import PropTypes from 'prop-types'

const Pagination = ({ links, currentPage, totalPages, onPaginationChange, style, ...props }) => {
  const preparePagination = name => {
    const pagination = links.filter(({ rel }) => rel === name)
    return {
      disabled: !pagination.length,
      link: !!pagination.length && pagination[0].href
    }
  }
  const paginationMap = {
    first: preparePagination('first'),
    prev: preparePagination('prev'),
    next: preparePagination('next'),
    last: preparePagination('last')
  }
  return (
    <div className="btn-line btn-line-stack-xs" style={{ textAlign: 'center', margin: '30px 0', ...style }} {...props}>
      <div className="btn-line">
        <a
          className="btn btn-secondary btn-square"
          disabled={paginationMap.first.disabled}
          onClick={() => onPaginationChange(paginationMap.first.link)}
        >
          <i className="icon icon-m">page_first</i>
        </a>
        <a
          className="btn btn-secondary btn-square"
          disabled={paginationMap.prev.disabled}
          onClick={() => onPaginationChange(paginationMap.prev.link)}
        >
          <i className="icon icon-m">chevronleft</i>
        </a>
        <div className="btn-line_text">{`${currentPage} / ${totalPages}`}</div>
        <a
          className="btn btn-secondary btn-square"
          disabled={paginationMap.next.disabled}
          onClick={() => onPaginationChange(paginationMap.next.link)}
        >
          <i className="icon icon-m">chevronright</i>
        </a>
        <a
          className="btn btn-secondary btn-square"
          disabled={paginationMap.last.disabled}
          onClick={() => onPaginationChange(paginationMap.last.link)}
        >
          <i className="icon icon-m">page_last</i>
        </a>
      </div>
    </div>
  )
}

Pagination.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object),
  currentPage: PropTypes.number,
  style: PropTypes.object,
  totalPages: PropTypes.number,
  onPaginationChange: PropTypes.func
}

Pagination.defaultProps = {
  currentPage: 0,
  links: [],
  style: {},
  totalPages: 0,
  onPaginationChange: () => {}
}

export default Pagination
